import React, { ReactNode } from 'react';

interface SummaryCardProps {
  icon: ReactNode;
  title: string;
  value: number;
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
  icon,
  title,
  value,
}) => {
  return (
    <div className="flex items-center p-6 bg-white rounded-2xl w-full">
      <div className="p-4 rounded-md text-blue-600 text-xl flex items-center justify-center">
        {icon}
      </div>
      {/*<div className="w-[72px] h-[72px] rounded-[4px] p-[16px] gap-[10px] flex items-center justify-center text-blue-600 text-xl">*/}
      {/*  {icon}*/}
      {/*</div>*/}

      <div className="ml-4">
        <div className="font-inter font-medium text-[24px] leading-[32px] tracking-[0px] text-[#000000]">
          {value?.toLocaleString()}
        </div>

        <div className="text-lg leading-[24px] tracking-[0px] font-normal font-[Inter] text-[#767F8C]">
          {title}
        </div>
      </div>
    </div>
  );
};

interface TotalSummaryCardProps {
  title: string;
  value: string | number;
  percentage?: number;
  isPositive?: boolean;
  isTotal?: boolean;
}

export const TotalSummaryCard: React.FC<TotalSummaryCardProps> = ({
  title,
  value,
  percentage,
  isPositive,
  isTotal,
}) => {
  return (
    <div className="flex justify-between p-6  w-full rounded-[10px] border-[1px] border-solid border-[#E4E4E7]">
      <div className="flex flex-col gap-5">
        <div className="text-[#71717A] text-lg leading-[18px] tracking-[1px] font-medium font-[PlusJakartaSans]">
          {title}
        </div>

        <div className="text-[21px] leading-[32px] tracking-[0px] font-bold font-[Inter] text-[#414146]">
          {value?.toLocaleString()}
        </div>
      </div>

      {!isTotal && isPositive && (
        <div className="text-green-500 text-sm font-semibold self-end">
          +{percentage}% ↑
        </div>
      )}
      {!isTotal && !isPositive && (
        <div className="text-red-600 text-sm font-semibold self-end">
          {percentage}% ↓
        </div>
      )}
    </div>
  );
};
